import { render, staticRenderFns } from "./UserIdentity.vue?vue&type=template&id=603a5bbc&scoped=true"
import script from "./UserIdentity.js?vue&type=script&lang=js&external"
export * from "./UserIdentity.js?vue&type=script&lang=js&external"
import style0 from "./UserIdentity.scss?vue&type=style&index=0&id=603a5bbc&prod&scoped=true&lang=scss&external"
import style1 from "../User.scss?vue&type=style&index=1&id=603a5bbc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603a5bbc",
  null
  
)

export default component.exports